// Mock data for SYNA website
 export const heroImage = "/imagefront1.png";

export const pillars = [
  {
    id: 1,
    number: "01",
    title: "Canal client",
    subtitle: "Parcours d'entrée",
    description: "On structure tous les points de contact entre vos clients et vous — site, téléphone, email, réseaux — pour qu'aucune demande ne se perde.",
    image: "image canal client.png",
    icon: "Users"
  },
  {
    id: 2,
    number: "02",
    title: "Moteur équipe",
    subtitle: "Traitement interne",
    description: "On organise la chaîne de traitement en interne : réception, affectation, traitement et réponse, sans friction ni perte de temps.",
    image: "moteur.png",
    icon: "Cog"
  },
  {
    id: 3,
    number: "03",
    title: "Pilotage",
    subtitle: "Suivi & indicateurs",
    description: "On installe les bons outils de suivi pour que vous gardiez la main sur vos délais, votre qualité de service et vos performances.",
    image: "pilotage.png",
    icon: "BarChart3"
  },
  {
    id: 4,
    number: "04",
    title: "Facturation fluide",
    subtitle: "Du devis à l'encaissement",
    description: "On fiabilise votre cycle de facturation de bout en bout pour éviter les oublis, les retards et les impayés.",
    image: "facturation1.png",
    icon: "FileText"
  },
  {
    id: 5,
    number: "05",
    title: "E-Facturation",
    subtitle: "Conformité 2026",
    description: "On vous accompagne dans la mise en conformité avec l'obligation de facturation électronique qui arrive en 2026. Anticipez sereinement.",
    image: "efact.png",
    icon: "Shield"
  }
];
 
export const completePack = {
  title: "SYNA 360°",
  subtitle: "Pack complet",
  description: "Les 5 piliers de votre activité structurés ensemble, pour une entreprise qui tourne sans accroc — de la première demande client à l'encaissement, en passant par la conformité e-facturation.",
  bonus: "Inclut la mise en conformité facture électronique 2026",
  image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f"
};

export const testimonials = [
  {
    id: 1,
    company: "Veezu",
    sector: "Agence de communication",
    quote: "Depuis que SYNA a structuré notre canal client, aucune demande ne se perd. Tout est traité rapidement et notre équipe est enfin alignée. Un gain de temps considérable au quotidien.",
    rating: 5,
    results: "0 perte de demande, équipe alignée, plus de demande traité"
  },
  {
    id: 2,
    company: "Iris Multiservice",
    sector: "Services",
    quote: "SYNA a remis de l'ordre dans notre organisation interne. Les tâches sont clairement réparties, les délais respectés et nos clients le ressentent directement. On travaille enfin sereinement.",
    rating: 5,
    results: "+35% de productivité équipe"
  },
  {
    id: 3,
    company: "AJ Fly Transport",
    sector: "Transport de marchandise",
    quote: "La gestion de nos tounés et des factures était un vrai casse-tête. Avec SYNA, tout le cycle est fluide, de la mission à l'émission du paiement. Nos équipes ont gagné en productivité et les délais d'encaissement ont drastiquement diminué.",
    rating: 5,
    results: "Délais d'encaissement réduits de 40%"
  },
  {
    id: 4,
    company: "Pharmacie",
    sector: "Santé",
    quote: "On anticipait l'e-facturation avec beaucoup d'inquiétude. SYNA nous a accompagnés pas à pas, de façon claire et rassurante. On est maintenant prêts bien avant l'échéance 2026.",
    rating: 5,
    results: "Conformité e-facturation 2026 assurée"
  }
];
 
export const blogPosts = [
  {
    id: 1,
    title: "Facture électronique 2026 : Êtes-vous prêt ?",
    excerpt: "Tout ce que vous devez savoir sur l'obligation de facturation électronique qui arrive en 2026 et comment vous y préparer dès maintenant.",
    category: "Conformité",
    date: "2025-01-15",
    readTime: "5 min",
    image: "https://images.unsplash.com/photo-1735825764485-93a381fd5779",
    author: "Sabrina Baala"
  },
  {
    id: 2,
    title: "5 signes que votre entreprise a besoin de structuration",
    excerpt: "Découvrez les symptômes du chaos opérationnel et comment les identifier avant qu'il ne soit trop tard pour votre croissance.",
    category: "Organisation",
    date: "2025-01-10",
    readTime: "7 min",
    image: "https://images.unsplash.com/photo-1730382624709-81e52dd294d4",
    author: "Sabrina Baala"
  },
  {
    id: 3,
    title: "Automatisation : Par où commencer ?",
    excerpt: "Guide pratique pour automatiser vos processus internes sans tout bouleverser. Les quick wins qui changent tout.",
    category: "Automatisation",
    date: "2025-01-05",
    readTime: "6 min",
    image: "https://images.unsplash.com/photo-1758876202468-5ffe0ee61f07",
    author: "Sabrina Baala"
  },
  {
    id: 4,
    title: "ROI : Mesurer l'impact de la structuration",
    excerpt: "Comment calculer le retour sur investissement d'une démarche de structuration opérationnelle avec des indicateurs concrets.",
    category: "Performance",
    date: "2024-12-20",
    readTime: "8 min",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
    author: "Sabrina Baala"
  }
];
 
export const stats = [
  { value: "300%", label: "ROI moyen sur 12 mois" },
  { value: "24h", label: "Temps de réponse client" },
  { value: "40%", label: "Gain de productivité" },
  { value: "98%", label: "Clients satisfaits" }
];
 
export const targetSectors = [
  {
    name: "Transport & Logistique",
    description: "Structuration des flux, traçabilité, gestion des plannings",
    icon: "Truck"
  },
  {
    name: "Événementiel",
    description: "Coordination équipe, gestion multi-projets, suivi clients",
    icon: "Calendar"
  },
  {
    name: "Services B2B",
    description: "Processus commercial, facturation, relation client",
    icon: "Briefcase"
  }
];
 
export const faqs = [
  {
    question: "Combien de temps dure une mission de structuration ?",
    answer: "Une mission SYNA dure en moyenne 3 à 6 mois selon la complexité de votre activité. Nous commençons toujours par un diagnostic de 2 semaines pour établir un plan d'action sur mesure."
  },
  {
    question: "Est-ce adapté à ma taille d'entreprise ?",
    answer: "SYNA accompagne les entreprises de 5 à 50 collaborateurs. Si vous ressentez le besoin de structurer sans savoir par où commencer, vous êtes au bon endroit."
  },
  {
    question: "Que se passe-t-il après la mission ?",
    answer: "Vous repartez avec des processus documentés, des outils opérationnels et votre équipe formée. Nous restons disponibles en support pendant 3 mois pour assurer la continuité."
  },
  {
    question: "Quel est l'investissement nécessaire ?",
    answer: "Le pack SYNA 360° offre le meilleur rapport qualité-prix pour une transformation complète. Nous établissons un devis personnalisé après le diagnostic initial gratuit, adapté à la taille et aux besoins spécifiques de votre entreprise."
  }
];
 
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Votre message a été envoyé avec succès !" });
    }, 1000);
  });
};
 
export const bookAppointment = async (appointmentData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Appointment booked:", appointmentData);
      resolve({ success: true, message: "Votre rendez-vous a été réservé !" });
    }, 1000);
  });
};
 
export const sendChatMessage = async (message) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Chat message:", message);
      const responses = [
        "Merci pour votre message ! Un conseiller SYNA vous répond dans quelques instants.",
        "Je vous propose de prendre rendez-vous pour un diagnostic gratuit. Quand êtes-vous disponible ?",
        "Parfait ! Je vous envoie notre brochure par email. Souhaitez-vous échanger avec un expert ?"
      ];
      resolve({ 
        success: true, 
        reply: responses[Math.floor(Math.random() * responses.length)] 
      });
    }, 800);
  });
};